module.exports = __webpack_public_path__ + "05_veryshort_black.d7242397.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_veryshort_black.png
// module id = 6P2b
// module chunks = 0